(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (function() {
  const STORAGE_KEY = 'facets-panel-visible';

  function applyFilterState(isOpen) {
    const panel = document.querySelector('.facets-block-wrapper--vertical');
    const wrapper = document.querySelector('.collection-wrapper');
    const btn = document.getElementById('facets-show-filter-toggle');

    if (!panel || !btn) return;

    panel.classList.toggle('facets--panel-visible', isOpen);
    if (wrapper) wrapper.classList.toggle('facets--filters-open', isOpen);
    btn.setAttribute('aria-expanded', String(isOpen));
    btn.querySelector('.facets-show-filter-icon').textContent = isOpen ? '−' : '+';
    btn.querySelector('.facets-show-filter-text').textContent = isOpen ? 'HIDE FILTER' : 'SHOW FILTER';
  }

  function bindButton() {
    const btn = document.getElementById('facets-show-filter-toggle');
    if (!btn || btn.dataset.persistInit) return;
    btn.dataset.persistInit = 'true';

    btn.addEventListener('click', function() {
      const panel = document.querySelector('.facets-block-wrapper--vertical');
      const isOpen = !panel.classList.contains('facets--panel-visible');
      applyFilterState(isOpen);
      localStorage.setItem(STORAGE_KEY, String(isOpen));
    });
  }

  function restoreState() {
    const savedState = localStorage.getItem(STORAGE_KEY) === 'true';
    applyFilterState(savedState);
    bindButton();
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(restoreState, 100));
  } else {
    setTimeout(restoreState, 100);
  }

  // Horizon fires this after AJAX filter re-render
  document.addEventListener('shopify:section:load', () => setTimeout(restoreState, 100));

  // Catch Horizon's internal re-render after filter selection
  document.addEventListener('render:section', () => setTimeout(restoreState, 100));
  document.addEventListener('facets:updated', () => setTimeout(restoreState, 100));

  // Fallback: watch for DOM mutations on the collection wrapper
  const observer = new MutationObserver(() => {
    const savedState = localStorage.getItem(STORAGE_KEY) === 'true';
    if (savedState) {
      const panel = document.querySelector('.facets-block-wrapper--vertical');
      if (panel && !panel.classList.contains('facets--panel-visible')) {
        restoreState();
      }
    }
  });

  const target = document.querySelector('.collection-wrapper') || document.body;
  observer.observe(target, { childList: true, subtree: true });

})();
  } catch(e) { console.error(e); }
})();

})();
